import constants from "../assets/constants";

export const tryRestoreLastPartnerId = () => {
  let sessionKey = constants.userSessionStorageKeys.lastPartnerId;
  return localStorage.getItem(sessionKey) || null;
};

export const storeLastPartnerId = partnerId => {
  let sessionKey = constants.userSessionStorageKeys.lastPartnerId;
  localStorage.setItem(sessionKey, partnerId);
};

export const tryRestoreCurrentTheme = () => {
  let sessionKey = constants.userSessionStorageKeys.currentTheme;
  let local = localStorage.getItem(sessionKey);
  local = parseInt(local);
  if (Number.isInteger(local)) {
    return local;
  }

  return 2;
};

export const storeCurrentTheme = themeId => {
  let sessionKey = constants.userSessionStorageKeys.currentTheme;
  localStorage.setItem(sessionKey, themeId);
};

export const tryRestoreLastAssessmentType = () => {
  let sessionKey = constants.userSessionStorageKeys.lastAssessmentType;

  let local = localStorage.getItem(sessionKey);
  if (local != null && constants.assessmentIDs.hasOwnProperty(local)) {
    return local;
  }
  // Default for Greeeley Demo
  return constants.assessmentIDs.omniHealthHistory;
};

export const storeLastAssessmentType = assessmentType => {
  let sessionKey = constants.userSessionStorageKeys.lastAssessmentType;
  localStorage.setItem(sessionKey, assessmentType);
};

export const tryRestoreLastBotpressBotID = () => {
  let sessionKey = constants.userSessionStorageKeys.lastBotpressBotId;
  let local = localStorage.getItem(sessionKey);
  return local;
};

export const storeLastBotpressBotID = themeId => {
  let sessionKey = constants.userSessionStorageKeys.lastBotpressBotId;
  localStorage.setItem(sessionKey, themeId);
};
